import { GraphqlApiBase, Logger, graphqlErrorToNotif, notif } from '@datalabs/edl_common_ui';
import { ALL_DATALABS_BUILDS_BOOKMARKS_INSTANCES, ARCHIVE_DATALAB_BUILD, BUILD_DATALAB, COMMENT_DATALAB, CREATE_DATALAB, CREATE_DATALAB_INSTANCE_MUTATION, DESTROY_DATALAB_MUTATION, EXTRACT_DATALAB_METADATA, GET_BUILD, GET_DATALAB, GET_DATALAB_ACCESS_LIST, GET_DATALAB_BUILDS, GET_DATALAB_COMMENTS, GET_LICENSES, GRANT_ACCESS, PUBLISH_DATALAB_BUILD, REMOVE_DATALAB, REVOKE_ACCESS, SCAN_DATALAB_BUILD, SEARCH_DATALABS, SEARCH_USERS, SET_BOOKMARK, SET_DATALAB_CLUSTERS, SET_DATALAB_REPOSITORY, SET_DATALAB_TYPE, SET_LAB_METADATA_ENTRIES, UNARCHIVE_DATALAB_BUILD, UNPUBLISH_DATALAB_BUILD, VALIDATE_DATALAB_BUILD } from "./dld-queries";
import { subscriptionService } from "./subscription-service";
const logger = new Logger("dld-api", "dld-graphql");
export class DLDApiService extends GraphqlApiBase {
  constructor() {
    super();
    this.subscriptionService = subscriptionService;
  }
  async createDatalabClass() {
    return this.call(CREATE_DATALAB).then(({ data: { createDatalabClass } }) => {
      return createDatalabClass;
    });
  }
  async setDatalabRepository(datalab, repository, branch) {
    return this.call(SET_DATALAB_REPOSITORY, {
      datalab,
      repository,
      branch,
    }).then(({ data: { setDatalabRepository } }) => {
      return setDatalabRepository;
    });
  }
  async extractDatalabMetadata(lab) {
    if (!lab)
      return {};
    return this.call(EXTRACT_DATALAB_METADATA, { lab }).then(({ data }) => {
      return data || {}; // return null will exploded once trying to destructure the data
    });
  }
  async setDatalabType(datalab, type) {
    return this.call(SET_DATALAB_TYPE, { datalab, type }).then(({ data: { setDatalabType } }) => {
      return setDatalabType;
    });
  }
  async setDatalabClusters(datalab, clusterIds) {
    return this.call(SET_DATALAB_CLUSTERS, { datalab, clusterIds }).then(({ data: { setDatalabClusters } }) => {
      return setDatalabClusters;
    });
  }
  async setDatalabMetadataEntries(datalab, entries) {
    return this.call(SET_LAB_METADATA_ENTRIES, { datalab, entries }).then(({ data }) => {
      return data;
    });
  }
  async getDatalabs(clusterId) {
    return this.call(ALL_DATALABS_BUILDS_BOOKMARKS_INSTANCES, { clusterId }).then(({ data }) => {
      return data || {};
    });
  }
  async getDatalab(datalab) {
    return this.call(GET_DATALAB, { datalab }).then(({ data }) => {
      return data || {}; // return null will exploded once trying to destructure the data
    });
  }
  async searchContent(search, clusterId) {
    return this.call(SEARCH_DATALABS, { qs: search, clusterId }).then(({ data }) => {
      return data || {};
    });
  }
  async setDatalabBookmark(build, bookmarked, comment) {
    return this.call(SET_BOOKMARK, { build, bookmarked, comment }).then(({ data: { bookmarkBuild } }) => {
      return bookmarkBuild;
    });
  }
  async getDatalabAccessList(datalabId) {
    return this.call(GET_DATALAB_ACCESS_LIST, { datalabId }).then(({ data: { getDatalabAccessList } }) => {
      return getDatalabAccessList;
    });
  }
  async revokeAccess(datalabId, userId) {
    return this.call(REVOKE_ACCESS, { datalabId, userId }).then(({ data: { revokeAccess } }) => {
      return revokeAccess;
    });
  }
  async grantAccess(datalabId, userId) {
    return this.call(GRANT_ACCESS, { datalabId, userId }).then(({ data: { grantAccess } }) => {
      return grantAccess;
    });
  }
  async archiveDatalabBuild(build) {
    return this.call(ARCHIVE_DATALAB_BUILD, { build }).then(({ data: { archiveBuild } }) => {
      return archiveBuild;
    });
  }
  async unarchiveBuildDatalabBuild(build) {
    return this.call(UNARCHIVE_DATALAB_BUILD, { build }).then(({ data: { unarchiveBuild } }) => {
      return unarchiveBuild;
    });
  }
  async removeDatalab(datalab) {
    return this.call(REMOVE_DATALAB, { datalab }).then(({ data: { removeDatalab } }) => {
      return removeDatalab;
    });
  }
  subscribeToBuildProgress(buildId, messageHandler, closeHandler) {
    return this.subscriptionService.subscribeToBuildProgress(buildId, messageHandler, closeHandler);
  }
  deleteSubscriptions(webSocket) {
    webSocket.onmessage = webSocket.onerror = webSocket.onopen = webSocket.onclose = null;
  }
  async getBuilds(datalabId) {
    return this.call(GET_DATALAB_BUILDS, { datalabId }).then(({ data }) => {
      return data;
    });
  }
  async getBuild(buildId) {
    return this.call(GET_BUILD, { id: buildId }).then(({ data: { build } }) => {
      return build && build[0];
    });
  }
  async buildDatalab(datalab) {
    return this.call(BUILD_DATALAB, { datalab }).then(({ data: { buildDatalab } }) => {
      return buildDatalab;
    });
  }
  async scanDatalabBuild(build) {
    return this.call(SCAN_DATALAB_BUILD, { build }).then(({ data: { scanDatalabBuild } }) => {
      return scanDatalabBuild && scanDatalabBuild.scanRef;
    });
  }
  async createDatalabInstance(payload) {
    return this.call(CREATE_DATALAB_INSTANCE_MUTATION, { input: payload }).then((res) => {
      if (!res.data) {
        // This following line shouldn't be so deep in the code
        const notification = graphqlErrorToNotif(res);
        notif(notification.title, notification.body);
        // better to manage using exception
        throw new Error("Can't create datalab instance");
        // alert("error, see javascript console");
      }
      return res.data.createDatalabInstance;
    });
  }
  async destroyDatalab(id) {
    return this.call(DESTROY_DATALAB_MUTATION, { id: id }).then((res) => {
      if (!res.data) {
        logger.error("Failed to destroy", res.data);
        return false;
      }
      else {
        // Emit anyway in case websocket is down
        logger.info("destroy datalab response", res.data);
        if (res.data.destroyDatalab == true) {
          window.dispatchEvent(new CustomEvent("datalabDestroyed", { detail: id }));
        }
        else {
          notif("Connection Error", "Couldn't delete the selected datalab.<br/>" +
            "This event has been logged for operator analysis<br/>" +
            "Please try again later");
        }
        return res.data.destroyDatalab;
      }
    });
  }
  async publishDatalabBuild(buildId) {
    return this.call(PUBLISH_DATALAB_BUILD, { build: buildId }).then(({ data }) => {
      return data && data.publishBuild;
    });
  }
  async revokeBuildModeration(buildId) {
    return this.call(UNPUBLISH_DATALAB_BUILD, { build: buildId }).then(({ data }) => {
      return data && data.revokeBuildModerationRequest;
    });
  }
  subscribeToLog(pipelineRef, messageHandler, closeHandler, lastId) {
    return this.subscriptionService.subscribeToLog(pipelineRef, messageHandler, closeHandler, lastId);
  }
  async validateDatalabBuild(build, valid, comment) {
    return this.call(VALIDATE_DATALAB_BUILD, { build, valid, comment }).then(({ data }) => {
      return data && data.validateBuild;
    });
  }
  async getLicenses() {
    return this.call(GET_LICENSES, {}).then(({ data: { getLicenses } }) => {
      return getLicenses;
    });
  }
  async getDatalabComment(datalab) {
    return this.call(GET_DATALAB_COMMENTS, { datalab }).then(({ data: { getDatalabComments } }) => {
      return getDatalabComments;
    });
  }
  async commentDatalab(datalab, comment) {
    return this.call(COMMENT_DATALAB, { datalab, comment }).then(({ data: { commentDatalab } }) => {
      return commentDatalab;
    });
  }
  async searchUsers(search) {
    return this.call(SEARCH_USERS, { name: search }).then(({ data }) => {
      return data;
    });
  }
}
